export const vendorServiceRouteName = {
  index: "vendor-services.index",
};

export const vendorServiceRoute = [
  {
    path: "/vendor-services",
    name: vendorServiceRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "vendor_service",
      breadcrumbs: () => {
        return [{ title: "Vendor Service" }];
      },
    },
  },
];
